import { render, staticRenderFns } from "./SettingPush.vue?vue&type=template&id=56ac3b0e&scoped=true&"
import script from "./SettingPush.vue?vue&type=script&lang=js&"
export * from "./SettingPush.vue?vue&type=script&lang=js&"
import style0 from "./SettingPush.vue?vue&type=style&index=0&id=56ac3b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac3b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
